import type React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconWheelchair16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="wheelchair">
            <path
                d="M6.23492 3.57332C6.70078 3.20714 7 2.63851 7 2C7 0.89543 6.10457 0 5 0C3.89543 0 3 0.89543 3 2C3 2.84129 3.51944 3.56125 4.25509 3.85667L5.01006 9.14143C5.08043 9.63408 5.50235 10 6.00001 10H10.323L12.0715 14.3714C12.1754 14.631 12.3832 14.8353 12.6446 14.9347C12.906 15.0341 13.1971 15.0195 13.4472 14.8944L15.4472 13.8944C15.9412 13.6474 16.1414 13.0468 15.8944 12.5528C15.6474 12.0588 15.0468 11.8586 14.5528 12.1056L13.5249 12.6195L11.9285 8.62861C11.7766 8.24896 11.4089 8.00001 11 8.00001H6.8673L6.72444 7H9C9.55228 7 10 6.55228 10 6C10 5.44772 9.55228 5 9 5H6.43873L6.23492 3.57332Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M3.03714 5.58093C1.23613 6.48441 0 8.34786 0 10.5C0 13.5376 2.46243 16 5.5 16C7.41085 16 9.0941 15.0256 10.0799 13.5465L9.5 12H8.66319C8.10145 13.1825 6.8962 14 5.5 14C3.567 14 2 12.433 2 10.5C2 9.37321 2.5325 8.37076 3.35958 7.73059L3.03714 5.58093Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconWheelchair24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="wheelchair">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.85166 2.01106C8.39783 1.92914 8.90701 2.30549 8.98894 2.85166L10.3612 12H17C17.3892 12 17.7431 12.2259 17.907 12.5789L20.8315 18.8779L22.8211 18.5161C23.3645 18.4173 23.8851 18.7777 23.9839 19.3211C24.0827 19.8645 23.7223 20.3851 23.1789 20.4839L20.4289 20.9839C19.981 21.0653 19.5347 20.834 19.343 20.4211L16.3618 14H9.5C9.005 14 8.58449 13.6379 8.51106 13.1483L7.01106 3.14834C6.92914 2.60217 7.30549 2.09299 7.85166 2.01106Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 8C8 7.44772 8.44771 7 9 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H9C8.44771 9 8 8.55228 8 8Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 5C9.10457 5 10 4.10457 10 3C10 1.89543 9.10457 1 8 1C6.89543 1 6 1.89543 6 3C6 4.10457 6.89543 5 8 5Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 8.58152C2.06817 9.76829 0 12.6426 0 16C0 20.4183 3.58172 24 8 24C11.7277 24 14.8599 21.4504 15.748 17.9999H13.6586C12.835 20.3304 10.6125 22 8 22C4.68629 22 2 19.3137 2 16C2 13.7792 3.2066 11.8401 5 10.8027V8.58152Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconWheelchair48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="wheelchair">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.3896 7.00612C17.9385 6.94513 18.4329 7.34066 18.4939 7.88957L20.395 25H35C35.4017 25 35.7644 25.2404 35.921 25.6104L41.0964 37.8431L44.7831 37.0238C45.3222 36.904 45.8564 37.2439 45.9762 37.7831C46.096 38.3222 45.7561 38.8564 45.2169 38.9762L40.7169 39.9762C40.2458 40.0809 39.7671 39.8341 39.579 39.3896L34.3373 27H19.5C18.9904 27 18.5624 26.6169 18.5061 26.1104L16.5061 8.11043C16.4451 7.56152 16.8407 7.06711 17.3896 7.00612Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 16C18 15.4477 18.4477 15 19 15H28C28.5523 15 29 15.4477 29 16C29 16.5523 28.5523 17 28 17H19C18.4477 17 18 16.5523 18 16Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 7C18.1046 7 19 6.10457 19 5C19 3.89543 18.1046 3 17 3C15.8954 3 15 3.89543 15 5C15 6.10457 15.8954 7 17 7ZM17 9C19.2091 9 21 7.20914 21 5C21 2.79086 19.2091 1 17 1C14.7909 1 13 2.79086 13 5C13 7.20914 14.7909 9 17 9Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 15.0891C5.57194 17.5144 1 23.7233 1 31C1 40.3888 8.61116 48 18 48C25.6487 48 32.1176 42.9487 34.2528 36.0001H32.1465C30.0873 41.826 24.5311 46 18 46C9.71573 46 3 39.2843 3 31C3 24.849 6.70229 19.5628 12 17.2481V15.0891Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
